
import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { RodeoService } from '../../../../../services/rodeo.service';
import { Rodeo } from '../../../../../model/rodeo';
import { AlertMessager } from '../../../../../lib/alertMessager';
import { StockGroup } from '../../../../../model/stock-group';
import { StockService } from '../../../../../services/stock.service';
import { SearchBoxComponentV2 } from '../../settings/search-box.component.v2';
import { Livestock } from '../../../../../model/livestock';

@Component({
    selector: 'stock-prompt',
    templateUrl: 'stock-prompt.html'
})
export class StockPromptPage {
    @ViewChild(SearchBoxComponentV2) searchBox;
    rodeo: Rodeo;
    stockGroup: StockGroup;
    livestock: Livestock[];

    brand: string;
    name: string;
    startNumber: number = 0;
    endNumber: number = 0;

    loadingData: boolean;

    constructor(navParams: NavParams, private viewController: ViewController, private alert: AlertMessager, private stockService: StockService,
        private loadingControl: LoadingController, private toast: ToastController) {
        this.rodeo = navParams.get('rodeo');
        this.stockGroup = navParams.get('stockGroup');

        if (!this.stockGroup)
            this.stockGroup = new StockGroup();
    }

    bulkUploadFileChanged($event): void {
        let bulkFile = $event.target.files[0];

        this.livestock = [];

        var reader = new FileReader();
        
        reader.onload = (e) => {
            var text = (e.target as any).result;
            var delimiter = ",";

            const rows = (text as string).split("\n");
            
            rows.forEach((row) => {
                var stockComponents = row.split(delimiter);
                this.livestock.push(new Livestock(stockComponents[0], stockComponents.length > 1 ? stockComponents[1] : null));
            });
        }
        
        reader.readAsText(bulkFile);
    }

    create() {
        var livestockToCreate = [];

        if (this.startNumber && this.startNumber >= 0 && this.endNumber && this.endNumber >= this.startNumber) {
            for (let i = this.startNumber; i <= this.endNumber; i++) {

                livestockToCreate.push({ brand: i, name: '' })
            }
        } else if (this.name || this.brand) {
            livestockToCreate.push({ brand: this.brand, name: this.name })
        }

        if (!this.livestock)
            this.livestock = [];

        this.livestock.push(...livestockToCreate);
        
        let loading = this.loadingControl.create({
            content: 'Creating Stock...',
        });

        loading.present();
        this.stockService.addLivestock(this.stockGroup.id, this.livestock)
            .then(data => {
                loading.dismiss();
                this.stockGroup.livestock.push(...data);
                this.toast.create({
                    message: 'Stock added!',
                    duration: 3000,
                    position: 'middle',
                }).present();

                this.viewController.dismiss();
            }, error => {
                loading.dismiss();
                this.alert.showError("Stock Add Error", error);
            });
    }

    cancel() {
        this.viewController.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/draw/stock/stock-prompt.ts